<template>
  <v-breadcrumbs class="pl-8" :items="appStateStore.breadcrumbs">
    <template #item="{ item, index }">
      <li v-if="item.to" class="v-breadcrumbs-item v-breadcrumbs-item--active">
        <router-link
          class="v-breadcrumbs-item--link"
          :to="item.to"
          @click="clearBreadcrumbs">
          {{ item.title }}
        </router-link>
      </li>
      <li
        v-else-if="index === appStateStore.breadcrumbs.length - 1"
        class="v-breadcrumbs-item v-breadcrumbs-item--disabled">
        {{ item.title }}
      </li>
      <li v-else class="v-breadcrumbs-item">{{ item.title }}</li>
    </template>
  </v-breadcrumbs>
</template>

<script>
import { mapStores } from "pinia";
import { useAppStateStore } from "@/stores/AppStateStore";

export default {
  name: "Breadcrumbs",
  computed: {
    ...mapStores(useAppStateStore),
  },
  methods: {
    clearBreadcrumbs() {
      this.appStateStore.breadcrumbs = [];
    },
  },
};
</script>
